
const convertLanguageToLocale = languageName => {

	let locale = "";

	switch ( languageName ) {

		case "Malyalam": {
			locale = "ml";
			break;
		}

		case "Hindi": {
			locale = "hi";
			break;
		}

		case "Tamil": {
			locale = "ta";
			break;
		}

		case "Telugu": {
			locale = "te";
			break;
		}

		case "Kannada": {
			locale = "kn";
			break;
		}

		default:
			break;

	}

	  return locale;
};

const convertLocaleToLanguage = locale => {

	let language = "";

	switch ( locale ) {
		case "en": {
			language = "English";
			break;
		}

		case "ml": {
			language = "Malyalam";
			break;
		}

		case "hi": {
			language = "Hindi";
			break;
		}

		case "ta": {
			language = "Tamil";
			break;
		}

		case "te": {
			language = "Telugu";
			break;
		}

		case "kn": {
			language = "Kannada";
			break;
		}

		default:
			break;

	}

	return language;
};

export {
	convertLanguageToLocale,
	convertLocaleToLanguage
};